/*
 * Copyright 2019 WeBank
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

import storage from "@dss/js/helper/storage";
import api from "@dss/js/service/api";
import CryptoJS from "crypto-js";
import { axios, TRACKURL } from "@/api";
//const pako = require("pako");
const appId = "MB-ISPQLY-0000",
  appKey = "c1af4cc708d140af1d040dc7837726e4";
export default {
  data: function() {
    return {
      SUPPORTED_LANG_MODES: Object.freeze([
        {
          rule: /(表详情)|(Table\sdetails)/,
          executable: false,
          isCanBeOpen: true,
        },
        {
          rule: /(建表向导)|(Table\screation\sguide)/,
          executable: false,
          isCanBeOpen: true,
        },
        {
          rule: /\.(bi)$/i,
          executable: false,
          logo: "fi-bi",
          isCanBeNew: false,
          isCanBeOpen: true,
        },
        {
          rule: /(新建查询)|(\.sql)$$/i,
          lang: "hql",
          executable: true,
          application: "spark",
          runType: "sql",
          ext: ".sql",
          scriptType: "hive",
          abbr: "sql",
          logo: "fi-spark",
          isCanBeNew: true,
          label: "Sparksql",
          isCanBeOpen: true,
          flowType: "sparksql",
        },
        // {
        //   rule: /(新建查询)/i,
        //   lang: "hql",
        //   executable: true,
        //   application: "hive",
        //   runType: "hql",
        //   ext: ".hql",
        //   scriptType: "hql",
        //   abbr: "hql",
        //   logo: "fi-hive",
        //   isCanBeNew: true,
        //   label: "Hive",
        //   isCanBeOpen: true,
        //   flowType: "hql",
        // },
        {
          rule: /\.(hql)$/i,
          lang: "hql",
          executable: true,
          application: "hive",
          runType: "hql",
          ext: ".hql",
          scriptType: "hql",
          abbr: "hql",
          logo: "fi-hive",
          isCanBeNew: true,
          label: "Hive",
          isCanBeOpen: true,
          flowType: "hql",
        },
        {
          rule: /\.(out)$/i,
          lang: "hql",
          executable: true,
          application: "pipeline",
          runType: "pipeline",
          ext: ".out",
          scriptType: "storage",
          abbr: "stor",
          logo: "fi-storage",
          isCanBeNew: true,
          label: "Storage",
          isCanBeOpen: true,
        },
        {
          rule: /\.scala$/i,
          lang: "java",
          executable: true,
          application: "spark",
          runType: "scala",
          ext: ".scala",
          scriptType: "scala",
          abbr: "scala",
          logo: "fi-scala",
          isCanBeNew: true,
          label: "Scala",
          isCanBeOpen: true,
          flowType: "scala",
        },
        {
          rule: /\.scala$/i,
          lang: "java",
          executable: true,
          application: "spark",
          runType: "function.mdq",
          ext: ".scala",
          scriptType: "scala",
          abbr: "scala",
          logo: "fi-scala",
          isCanBeNew: false,
          label: "Scala",
          isCanBeOpen: true,
        },
        {
          rule: /\.jdbc$/i,
          lang: "hql",
          executable: true,
          application: "jdbc",
          runType: "jdbc",
          ext: ".jdbc",
          scriptType: "jdbc",
          abbr: "jdbc",
          logo: "fi-jdbc",
          isCanBeNew: true,
          label: "JDBC",
          isCanBeOpen: true,
          flowType: "jdbc",
        },
        {
          rule: /\.python$/i,
          lang: "python",
          executable: true,
          application: "python",
          runType: "python",
          ext: ".python",
          scriptType: "python",
          abbr: "py",
          logo: "fi-python",
          isCanBeNew: true,
          label: "Python",
          isCanBeOpen: true,
          flowType: "python",
        },
        {
          rule: /\.py$/i,
          lang: "python",
          executable: true,
          application: "spark",
          runType: "python",
          ext: ".py",
          scriptType: "pythonSpark",
          abbr: "py",
          logo: "fi-spark-python",
          isCanBeNew: true,
          label: "PythonSpark",
          isCanBeOpen: true,
          flowType: "pyspark",
        },
        {
          rule: /\.r$/i,
          lang: "r",
          executable: true,
          application: "spark",
          runType: "r",
          ext: ".r",
          scriptType: "r",
          abbr: "r",
          logo: "fi-r",
          isCanBeNew: true,
          label: "R",
          isCanBeOpen: true,
        },
        {
          rule: /\.sh$/i,
          lang: "sh",
          executable: true,
          application: "shell",
          runType: "shell",
          ext: ".sh",
          scriptType: "shell",
          abbr: "shell",
          logo: "fi-r",
          isCanBeNew: true,
          label: "Shell",
          isCanBeOpen: true,
          flowType: "shell",
        },
        {
          rule: /\.qmlsql$/i,
          lang: "hql",
          executable: false,
          application: "spark",
          runType: "sql",
          ext: ".qmlsql",
          scriptType: "qmlsql",
          abbr: "qmlsql",
          logo: "fi-spark",
          isCanBeNew: false,
          label: "QMLSQL",
          isCanBeOpen: true,
        },
        {
          rule: /\.qmlpy$/i,
          lang: "python",
          executable: false,
          application: "spark",
          runType: "python",
          ext: ".qmlpy",
          scriptType: "qmlpy",
          abbr: "qmlpy",
          logo: "fi-python",
          isCanBeNew: false,
          label: "QMLPy",
          isCanBeOpen: true,
        },
        {
          rule: /\.txt$/i,
          lang: "text",
          executable: false,
          application: null,
          runType: null,
          ext: ".txt",
          scriptType: "txt",
          abbr: "",
          logo: "fi-txt",
          isCanBeNew: false,
          isCanBeOpen: true,
        },
        {
          rule: /\.log$/i,
          lang: "text",
          executable: false,
          application: null,
          runType: null,
          ext: ".log",
          scriptType: "txt",
          abbr: "",
          logo: "fi-log",
          isCanBeNew: false,
          isCanBeOpen: true,
        },
        {
          rule: /\.xls$/i,
          logo: "fi-xls",
          isCanBeNew: false,
          isCanBeOpen: false,
        },
        {
          rule: /\.xlsx$/i,
          logo: "fi-xlsx",
          isCanBeNew: false,
          isCanBeOpen: false,
        },
        {
          rule: /\.csv$/i,
          logo: "fi-csv",
          isCanBeNew: false,
          isCanBeOpen: false,
        },
        {
          rule: /\.jar$/i,
          logo: "fi-jar",
          isCanBeNew: false,
          isCanBeOpen: false,
        },

        // DATAX
        {
          rule: /\.datax\.task$/i,
          lang: "text",
          executable: true,
          application: "datax",
          runType: "datax",
          ext: ".datax.task",
          scriptType: "datax",
          abbr: "datax",
          logo: "fi-txt",
          isCanBeNew: true,
          label: "DataX",
          isCanBeOpen: true,
          flowType: "datax",
        },
        // HDDT
        {
          rule: /\.hddt\.task$/i,
          lang: "text",
          executable: true,
          application: "hddt",
          runType: "hive",
          ext: ".hddt.task",
          scriptType: "hddt",
          abbr: "hddt",
          logo: "fi-txt",
          isCanBeNew: true,
          label: "HDDT",
          isCanBeOpen: true,
          flowType: "hddt",
        },
      ]),
    };
  },
  beforeRouteLeave(to, from, next) {
    if (typeof this.beforeLeaveHook === "function") {
      let hookRes = this.beforeLeaveHook();
      if (hookRes === false) {
        next(false);
      } else if (hookRes && hookRes.then) {
        hookRes.then((flag) => {
          next(flag);
        });
      } else {
        next(true);
      }
    } else {
      next(true);
    }
  },
  created: function() {},
  mounted: function() {},
  beforeDestroy: function() {},
  destroyed: function() {},
  methods: {
    getUserName() {
      //const userInfo = storage.get("userInfo", "SESSION");
      const baseInfo = storage.get("baseInfo", "local");
      return baseInfo && baseInfo.userInfo.basic.username;
    },
    getVsBiUrl() {
      const baseInfo = storage.get("baseInfo", "local");
      const vsBi =
        baseInfo.applications.find((item) => item.name === "visualis") || {};
      return vsBi.url;
    },
    // getQualitisUrl() {
    //   const baseInfo = storage.get('baseInfo');
    //   const info = baseInfo.applications.find((item) => item.name === 'qualitis') || {};
    //   return info.projectUrl;
    // },
    getProjectJson() {
      const baseInfo = storage.get("baseInfo", "local");
      const vsBi =
        baseInfo.applications.find((item) => item.name === "visualis") || {};
      // projectMsg.projectJson  这个变为了applications 里面的enhancejson
      const projectJson = vsBi.enhanceJson;
      return projectJson;
    },
    getDataReportUrl() {
      const projectJson = this.getProjectJson();
      return projectJson ? JSON.parse(projectJson).dailyReport : "";
    },
    getWaterMask() {
      const projectJson = this.getProjectJson();
      return projectJson ? JSON.parse(projectJson).watermark : true;
    },
    getRsDownload() {
      const projectJson = this.getProjectJson();
      return projectJson ? JSON.parse(projectJson).rsDownload : true;
    },
    getFAQUrl() {
      const baseInfo = storage.get("baseInfo", "local");
      const url = baseInfo.DWSParams.faq;
      return url;
    },
    getSupportModes() {
      return this.SUPPORTED_LANG_MODES;
    },
    getLogManager() {
      const baseInfo = storage.get("baseInfo", "local");
      if (!baseInfo.userInfo.role || !baseInfo.userInfo.role[0]) {
        return false;
      }
      const findRole = baseInfo.userInfo.role.find(
        (role) => role.name === "logAdmin"
      );
      return !!findRole;
    },
    getProjectList() {
      const baseInfo = storage.get("baseInfo", "local");
      return baseInfo.applications;
    },
    Bytes2HexString(arrBytes) {
      var str = "";
      for (var i = 0; i < arrBytes.length; i++) {
        var tmp;
        var num = arrBytes[i];
        if (num < 0) {
          //此处填坑，当byte因为符合位导致数值为负时候，需要对数据进行处理
          tmp = (255 + num + 1).toString(16);
        } else {
          tmp = num.toString(16);
        }
        if (tmp.length == 1) {
          tmp = "0" + tmp;
        }
        str += tmp;
      }
      return str;
    },
    sendTrack(data) {
      let timestamp = new Date().getTime().toString();
      let userId = localStorage.getItem("userId");
      data = data.map((item) => {
        item["timestamp"] = timestamp;
        item["userId"] = userId;
        item["workspaceId"] = window.localStorage.getItem("workspaceId");
        return item;
      });
      // let message = pako.gzip(JSON.stringify([data]), { to: "string" });
      let message = JSON.stringify(data);
      let sign = CryptoJS.MD5(message + appKey).toString();
      let headers = {
        appId,
        sign,
        // contentEncoding: "gzip",
        sendTime: timestamp,
        sequenceId: Object.values(data[0]).join("_"),
        category: "web",
        "Content-Type": "application/json",
      };
      let options = {
        method: "post",
        url: TRACKURL,
        headers,
        data: message,
      };
      return axios(options);
    },
    // getCommonProjectId(type, query) {
    //   return api.fetch(`/dss/getAppjointProjectIDByApplicationName`, {
    //     projectID: query.projectID,
    //     applicationName: type
    //   }, 'get').then((res) => {
    //     window.console.log(res)
    //     localStorage.setItem('appJointProjectId', res.appJointProjectID);
    //   })
    // },
    // async gotoCommonIframe(type, query = {}) {
    //   const baseInfo = storage.get('baseInfo');
    //   const info = baseInfo.applications.find((item) => item.name === type) || {};
    //   // 根据是否有projectid来确定是走首页还是工程页
    //   let url = '';
    //   if (query.projectID) {
    //     await this.getCommonProjectId(type, query);
    //     url = info.projectUrl
    //   } else {
    //     localStorage.removeItem('appJointProjectId')
    //     url = info.homepageUrl
    //   }
    //   // 如果没有提示用户功能暂未开发
    //   if (Object.keys(info).length === 0) {
    //     this.$Message.warning(this.$t('message.constants.warning.comingSoon'));
    //   } else {
    //     if (!info.ifIframe) {
    //       this.$router.push({path: url, query});
    //     } else {
    //       this.$router.push({name: 'commonIframe', query: {
    //         ...query,
    //         url,
    //         type
    //       }})
    //     }
    //   }
    // }
  },
};
